import type { VoidFunctionComponent } from 'react';

import styles from './SearchPrompt.module.less';

/**
 * Placeholder shown in the Internal Tools search cards before the admin has entered a query,
 * standing in for the results table until a search is active.
 */
export const SearchPrompt: VoidFunctionComponent = () => (
  <p className={styles.searchPrompt}>Start searching to see results</p>
);
